module.exports = __webpack_public_path__ + "static/google-button-d45fbcb9f90c4d196f0a12f2f821a894.png";